// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox-asset-card_root__ofxYS"};